export default "__VITE_ASSET___uksB8qB__"